import { render } from "./UsersPage.vue?vue&type=template&id=5b5f62ba&ts=true"
import script from "./UsersPage.vue?vue&type=script&lang=ts"
export * from "./UsersPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Configuration/Users/UsersPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b5f62ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b5f62ba', __exports__)) {
    api.reload('5b5f62ba', __exports__)
  }
  
  module.hot.accept("./UsersPage.vue?vue&type=template&id=5b5f62ba&ts=true", () => {
    api.rerender('5b5f62ba', render)
  })

}


export default __exports__